module.exports = __webpack_public_path__ + "static/img/patho-edema-low-3lUrGL0M.80a0e194.png";